import * as browserHelpers from 'helpers/browser';
import * as koDataHelpers from 'helpers/koData';
import * as requestsHelpers from 'helpers/requests';
import * as settingsHelpers from 'helpers/settings';
import { StringHelpers } from 'helpers/string';
import 'libraries/bootstrap';

Math.trunc = Math.trunc || function (x) {
    if (isNaN(x)) {
        return NaN;
    }
    if (x > 0) {
        return Math.floor(x);
    }
    return Math.ceil(x);
};

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (str) {
        return this.lastIndexOf(str, 0) === 0;
    };
}

if (!$.browser)
    $.browser = require('helpers/browser').browser;

var WCC = {
    koData: koDataHelpers.koData,
    Settings: settingsHelpers.settings,
    Enums: enums,
    Labels: labels,
    Messages: messages,
    ContentMessages: contentMessages,
    System: require('helpers/system').SystemHelpers,
    API: require('helpers/api').APIHelpers,
    Uploaders: require('helpers/fineUploaders').FineUploadersHelpers,
    currentUser: settingsHelpers.getSetting('CurrentUser'),

    emptyFn: function () { },

    // Base function for proper inheritance
    extend: function () {
        // inline overrides function
        var overrideFunc = function (obj) {
            for (var prop in obj) {
                this[prop] = obj[prop];
            }
        };
        // constructor of simple Object class
        var baseObjConstr = Object.prototype.constructor;
        // create closure function
        return function (subBase, supPar, overrides) {
            // if function called with 2 paramters, superclass and object literal
            if (typeof supPar == 'object') {
                // change vars, because called with 2 params
                overrides = supPar;
                supPar = subBase;
                // if contructor won't overriden, call parent with all passed args
                subBase = (overrides.constructor != baseObjConstr) ? overrides.constructor : function () { supPar.apply(this, arguments); };
            }
            // create temp function and vars with prototypes
            var F = function () { }, subBaseProt, supParProt = supPar.prototype;
            // change temp functiion prototype
            F.prototype = supParProt;
            // create new incstance of prototype, this will solve problem of one prototype chain
            subBaseProt = subBase.prototype = new F();
            // take care of inheritance, reset constructor
            subBaseProt.constructor = subBase;
            // make link to parent contructor
            subBase.superclass = supParProt;
            // reset parent constructor, don't know for what
            if (supParProt.constructor == baseObjConstr) {
                supParProt.constructor = supPar;
            }
            // add override function
            subBase.override = function (obj) {
                WCC.override(subBase, obj);
            };
            // add override to prototype
            subBaseProt.override = overrideFunc;
            // copy properties
            WCC.override(subBase, overrides);
            // add extend function
            subBase.extend = function (obj) { WCC.extend(subBase, obj); };
            // return new class (constructor function)
            return subBase;
        };
    }(),

    /**
		 * Copies and replaces properties of one object with another
		 * @param {Object} baseclass
		 * @param {Object} object literal
		 * @method override
		 */
    override: function (origClass, overrides) {
        if (overrides) {
            var origProt = origClass.prototype;
            // copy all properties to prototype
            for (var method in overrides) {
                origProt[method] = overrides[method];
            }

            if (WCC.isIE && overrides.toString != origClass.toString) {
                origProt.toString = overrides.toString;
            }
        }
    },

    ajaxRequest: requestsHelpers.ajaxRequest,
    beginRequest: requestsHelpers.beginRequest,
    handleSuccessRequest: requestsHelpers.handleSuccessRequest,
    handleErrorRequest: requestsHelpers.handleErrorRequest,

    isIE: browserHelpers.isIE,
    isMobileIE: browserHelpers.isMobileIE,
    isOldIE: browserHelpers.isOldIE,
    isIE8: browserHelpers.isIE8,

    // Timeout for delayed redirects 
    redirectTimeout: 10000,

    // Default interval for Slide animation
    slideInterval: 200,

    // Default interval for Fade animation
    fadeInterval: 200,

    getSetting: settingsHelpers.getSetting,

    setSetting: settingsHelpers.setSetting,

    getKOData: koDataHelpers.getKOData,

    emptyGuid: '00000000-0000-0000-0000-000000000000',

    isNullOrEmpty: StringHelpers.isNullOrEmpty,
    isNullOrWhitespace: StringHelpers.isNullOrWhitespace,
    cleanString: StringHelpers.cleanString,
    trimLeft: StringHelpers.trimLeft,
    isNotNullOrEmpty: StringHelpers.isNotNullOrEmpty,

    isButtonEnabled: function (btn) {
        return !(btn.hasClass('disabled') || btn.closest('.button').hasClass('disabled'));
    },

    enableButton: function (btn, enable) {
        if (enable) {
            btn.removeClass('disabled');
            btn.closest('.button').removeClass('disabled');
        }
        else {
            btn.addClass('disabled');
            btn.closest('.button').addClass('disabled');
        }
    },

    toFirstCharUpperString: StringHelpers.toFirstCharUpperString,
    toFirstCharLowerString: StringHelpers.toFirstCharLowerString,

    isMobile: function () {
        var check = false;

        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || window.opera);

        return check;
    },

    escapeStringForRegEx: StringHelpers.escapeStringForRegEx,

    extractOffsetFromDate: function (date) {
        //Extracts offset from a date. For e.g., extracts +07:00 from 2019-12-13T01:00:10.5299785+07:00
        var offset = /[\+\-]{1}\d{2}:\d{2}/.exec(date);
        if (offset == null)
            return null
        return offset[0];
    },

    convertDateToTimezoneInDate: function (date) {
        var offset = WCC.extractOffsetFromDate(date);

        if (offset == null)
            throw "Invalid offset for the date " + date; //Better to crash it otherwise dates might be wrongly saved. This is not likely to happen though

        return moment(date).utcOffset(offset);
    }
};


///////////////////////////////////////
///                                 ///
///            BasePage             ///
///                                 ///
///////////////////////////////////////


WCC.BasePage = WCC.extend(WCC.emptyFn, {

    tooltipsAreUsed: false,

    settings: {},

    serverCurrentTime: null,

    pageInitTime: new Date(),

    constructor: function () {
        var pageObj = this;
        this.serverCurrentTime = new Date(WCC.getSetting("ServerCurrentTime"));
        WCC.System.setServerCurrentTime(this.serverCurrentTime);
        WCC.ajaxRequest(WCC.getSetting("WccApiUrl") + '/api/sys/?action=GetServerTime&rnd=' + Math.random(), 'GET', null, function (data) {
            pageObj.pageInitTime = new Date();
            WCC.System.setPageInitTime(pageObj.pageInitTime);
            pageObj.serverCurrentTime = new Date(data.ServerCurrentTime);
        });

        this.initContainerSizeAdjustment($('#workArea'));

        if (!WCC.Settings.DoNotInitScrollTracking) {
            this.initScrollTracking();
        }
        this.bindTooltipsHiding();
        this.loadSettings();
        this.initMessenger();
        //this.initSearchControl();
        //this.initToolbarSettings();
    },

    initScrollTracking: function () {
        WCC.System.initScrollTracking();
    },

    //adjustHeightForNoContent: function () {
    //    var pageObj = this;
    //    setTimeout(function () { //for knockout we need to time it slightly
    //        var noFullWidthWrapper = $('.noFullWidthWrapper');
    //        if (noFullWidthWrapper.length > 0) {
    //            pageObj.initContainerSizeAdjustment(noFullWidthWrapper);
    //        }
    //        else {
    //            var newScreenContainer = $('.notification:visible');
    //            if (newScreenContainer.length > 0) {
    //                pageObj.initContainerSizeAdjustment(newScreenContainer);
    //            }
    //        }
    //    }, 100);
    //},

    initContainerSizeAdjustment: function (containerObj, callbackFunc) {
        if (!containerObj.length) {
            return;
        }
        var pageObj = this;
        var adjustmentFunc = function () {
            var bottomToolbar = $('#titledMenuToolbarBottom'),
                bottomToolbarHeight = bottomToolbar.length > 0 && bottomToolbar.css('display') != 'none' ? bottomToolbar.outerHeight() + parseInt(bottomToolbar.css('margin-bottom').replace('px', '')) : 0,
                padding = parseInt(containerObj.css('padding-top')) + parseInt(containerObj.css('padding-bottom')) + parseInt($('#workArea').css('padding-bottom')),
                marginTop = parseInt(containerObj.css('margin-top')),
                margin = (marginTop > 0 ? marginTop : 0) + parseInt(containerObj.css('margin-bottom'));
            containerObj.css("min-height", $(window).height() - $('#footer').outerHeight() - (WCC.isOldIE() ? 15 : 0) - containerObj[0].offsetTop - margin - padding - bottomToolbarHeight);
            if (callbackFunc) {
                callbackFunc.call(pageObj);
            }
        };

        adjustmentFunc.call(this);
        $(window).resize(function () {
            adjustmentFunc.call(this);
        });
    },

    bindDropDown: function (dropdown, items) {
        var boundItems = [];
        for (var i = 0; i < items.length; i++)
            boundItems.push('<option value="' + items[i].value + '">' + items[i].text + '</option>');
        dropdown.html(boundItems.join(''));
    },

    revertToDefaults: function (context) {
        $(':input[type != password][data-default-value != ""]', context).each(function () {
            var thisRef = $(this),
                defaultVal = thisRef.attr('data-default-value');
            if (thisRef.attr('type') == 'checkbox') {
                if (defaultVal == "True" && !thisRef.is(":checked") || defaultVal == "False" && thisRef.is(":checked")) {
                    thisRef.click();
                }
            }
            else {
                if (thisRef.val() != defaultVal) {
                    thisRef.val(defaultVal);
                    thisRef.change();
                }
            }
        });
        $(':input[type=password]', context).val('');
    },

    resetDefaults: function (context) {
        $(':input', context).each(function () {
            var thisRef = $(this),
                defaultVal = thisRef.attr('data-default-value');
            if (thisRef.attr('type') == 'checkbox') {
                var isChecked = thisRef.is(":checked").toString();
                thisRef.attr('data-default-value', isChecked.slice(0, 1).toUpperCase() + isChecked.slice(1));
            }
            else {
                if (thisRef.val() != defaultVal) {
                    thisRef.attr('data-default-value', thisRef.val());
                }
            }
        });
    },

    enableForm: function (context, enable, callBack) {
        if (enable) {
            $(":input:not(.cantBeDisabled)", context).prop("disabled", false); //add cantBeDisabled if you don't want this global function to enable/disable that control
            $("a.canBeDisabled").prop("disabled", false).removeClass('disabledLink'); //make sure to add the class 'canBeDisabled' to the menu links that are used in smart dropdowns

            //These need to be enabled when we borrow respective plugins from V1
            /*$(":input.select2", context).select2("enable");
            $('.icheck').iCheck('enable');

            var wysiHtmlEditors = $('.wysiHTML'); //add this class to all WysiHtml editors

            if (wysiHtmlEditors.length) {
                wysiHtmlEditors.each(function () {
                    var thisEditor = $(this);
                    setTimeout(function () {
                        thisEditor.data("wysihtml5").editor.enable();
                        $("[id*='wysihtml5-toolbar']", thisEditor).show();
                    }, 500);
                });
            }

            var dateTimeFields = $('.form_datetime'); //add this class to all date-time pickers

            if (dateTimeFields.length > 0) {
                dateTimeFields.each(function () {
                    var picker = $(this).data('datetimepicker');
                    if (picker != null)
                        picker.enable();
                });
            }*/
        }
        else {
            $(":input:not(.cantBeDisabled)", context).prop("disabled", true).removeClass('inputError'); //add cantBeDisabled if you don't want this global function to enable/disable that control
            $("a.canBeDisabled").prop("disabled", true).addClass('disabledLink'); //make sure to add the class 'canBeDisabled' to the menu links that are used in smart dropdowns

            //These need to be enabled when we borrow respective plugins from V1
            /*$(":input.select2", context).select2("disable");
            $('.icheck').iCheck('disable');

            var wysiHtmlEditors = $('.wysiHTML'); //add this class to all WysiHtml editors

            if (wysiHtmlEditors.length) {
                wysiHtmlEditors.each(function () {
                    var thisEditor = $(this);
                    setTimeout(function () {
                        thisEditor.data("wysihtml5").editor.disable();
                        $("[id*='wysihtml5-toolbar']", thisEditor).hide();
                    }, 500);
                });
            }

            var dateTimeFields = $('.form_datetime'); //add this class to all date-time pickers

            if (dateTimeFields.length > 0) {
                dateTimeFields.each(function () {
                    var picker = $(this).data('datetimepicker');
                    if (picker != null)
                        picker.disable();
                });
            }*/
        }

        if (callBack != null)
            callBack.call(this);
    },

    hideAllToolbarButtons: function (toolbar, btnClass, exceptions) {
        toolbar = typeof toolbar == "object" ? toolbar : $(toolbar);
        toolbar.find(btnClass).each(function (idx, el) {
            var btn = $(el);
            if (exceptions.indexOf(btn.attr('id')) == -1) {
                btn.addClass('hide');
            }
        });
    },

    millisecondsFromInit: function () {
        return new Date().getTime() - WCC.CurrentPage.pageInitTime.getTime();
    },

    convertDateToMomentInterval: function (createDate) {
        if (WCC.isNotNullOrEmpty(WCC.API.language)) {
            moment.locale(WCC.API.language);
        }
        if (WCC.CurrentPage.serverCurrentTime.getTime() + new Date().getTime() - WCC.CurrentPage.pageInitTime.getTime() - new Date(createDate).getTime() <= 0) {
            createDate = WCC.CurrentPage.serverCurrentTime.getTime() + new Date().getTime() - WCC.CurrentPage.pageInitTime.getTime() - 1000;
        }
        return moment(new Date(createDate)).
                from(moment(WCC.CurrentPage.serverCurrentTime).
                add(Math.floor((new Date().getTime() - WCC.CurrentPage.pageInitTime.getTime()) / 1000), "second"));
    },

    loadSettings: function () {
        var pageObj = this;
        $.each(this.settings, function (settingName) {
            pageObj.settings[settingName] = WCC.getSetting(settingName, pageObj.settings[settingName]);
        });
    },

    initMessenger: function () {
        Messenger.options = {
            extraClasses: 'messenger-fixed messenger-top',
            theme: 'block'
        };
    },

    initSearchControl: function () {
        var searchButton = $("#searchBtn"),
            searchHidingTimeout,
            animationStarted = false,
            timerScheduled = false;
        if (searchButton.length) {
            searchButton.addClass('closed');

            var searchControl = $("#searchControl"),
                hideFunc = function () {
                    timerScheduled = false;
                    searchControl.val("");
                    animationStarted = true;
                    searchControl.animate({ width: "0px" },
                        {
                            duration: 300,
                            complete: function () {
                                searchControl.hide();
                                $(".glyph", searchButton).html("&#57384;").attr('style', '');
                                animationStarted = false;
                            }
                        });

                };
            searchButton.click(function () {
                if (animationStarted) {
                    return;
                }
                if (!searchControl.is(":visible")) {
                    searchButton.removeClass('closed').addClass('opened');
                    $(".glyph", searchButton).html("&#57864;").attr('style', 'position:relative;top:2px;');
                    searchControl.show();
                    animationStarted = true;
                    searchControl.animate({ width: "250px" },
                        {
                            duration: 300,
                            complete: function () {
                                searchControl.focus();
                                animationStarted = false;
                            }
                        });
                }
                else {
                    searchButton.removeClass('opened').addClass('closed');
                    if (timerScheduled == true)
                        clearTimeout(searchHidingTimeout);

                    hideFunc();
                }
                return false;
            });
            searchControl.focusout(function () {
                if (searchControl.val() == "") {
                    timerScheduled = true;

                    searchHidingTimeout = setTimeout(function () {
                        hideFunc();
                    }, 2000);
                }
            });
            searchControl.focusin(function () {
                if (searchHidingTimeout) {
                    clearTimeout(searchHidingTimeout);
                }
            });
            searchControl.keyup(function (e) {
                if (e.keyCode == 27) {
                    if (searchHidingTimeout) {
                        clearTimeout(searchHidingTimeout);
                    }
                    hideFunc();
                }
            });

            //if browser has auto-complete on, clear the field on load
            searchControl.val('');
        }
    },

    initDateTimePicker: function (context, customOptions) {
        var pageObj = this,
            pickerOptions = {
                format: WCC.getSetting('DatePickerDisplayFormat', 'dd M yyyy hh:ii'), //using getSetting here instead of this.settings collection as this method is called from external WCCBase's initTimeZoneChanger function also
                linkFormat: WCC.getSetting('DatePickerValueFormat', 'yyyy-mm-ddThh:ii'),
                autoclose: true,
                pickerPosition: "bottom-left"
            };

        if (customOptions != null) {
            $.extend(pickerOptions, customOptions);
        }
        if (WCC.getSetting('Language', '') != '') {
            pickerOptions.language = WCC.getSetting('Language', '');
        }

        $('.form_datetime', context).each(function () {
            var domObj = $(this),
                initCtrl = $('#' + domObj.attr('data-link-field')),
                initCtrlVal = initCtrl.val(),
                initDate = initCtrlVal.length > 0 ? new Date(moment(initCtrlVal).format()) : initCtrlVal;

            pickerOptions.bootcssVer = 3;

            if (initDate != '') {
                pickerOptions.initialDate = initDate;
            }

            if (domObj.attr("data-datetimemode") == "dateOnly") {
                pickerOptions.minView = 2;
                pickerOptions.format = pickerOptions.format.replace("hh:ii", "").trim();
            }

            domObj.datetimepicker(pickerOptions);

            if (domObj.attr("data-min-view") == "1") {
                domObj.datetimepicker().on('changeDate', function (ev) {
                    if (ev.date) {
                        ev.date.setMinutes(0);
                    }
                });
            }

            if (initDate != '') {
                var picker = domObj.data('datetimepicker');
                domObj.children('input[type="text"]').first().val(picker.getFormattedDate());
            }
        });

        //make the textboxes readonly
        $('.dateDisplay').keydown(function (event) {
            event.preventDefault();
        });
    },

    initTimeZones: function (context) {
        var pageObj = this,
            ddlCountry = context.find('.countrySelect'),
            dvRegion = $('.dvRegion'),
            ddlRegion = context.find('.regionSelect');
        if (ddlCountry.length != 0 && ddlRegion.length != 0) {

            if (ddlCountry.val() == "") {
                dvRegion.hide();
                ddlRegion.val("");
            }

            ddlCountry.change(function () {
                pageObj.loadCountryRegions(context, ddlCountry, ddlRegion);
            });
        }
    },

    loadCountryRegions: function (context, _ddlCountry, _ddlRegion) {
        var ddlCountry = _ddlCountry || context.find('.countrySelect'),
            ddlRegion = _ddlRegion || context.find('.regionSelect'),
            dvRegion = context.find('.dvRegion'),
            dvRegionLoader = context.find('.dvRegionLoader'),
            hdHasRegion = context.find('.hasRegion');

        if (ddlCountry.val() == "") {
            dvRegion.hide();
            ddlRegion.val("");
            return;
        }

        dvRegion.hide();
        dvRegionLoader.show();

        $.getJSON(WCC.getSetting("WccApiUrl") + "/api/timezones", { ZoneCode: ddlCountry.val() }, function (Items) {
            dvRegionLoader.hide();
            //update our Regions
            if (Items.length > 0) {
                var items = '<option value="">&lt;Please Choose One&gt;</option>',
                    selectedRegion = context.find("#selectedRegion").val();

                for (var i = 0; i < Items.length; i++) {
                    var selected = selectedRegion == Items[i].ZoneCode ? "selected" : "";
                    items += '<option value="' + Items[i].ZoneCode + '" ' + selected + '>' + Items[i].Title + '</option>';
                }

                ddlRegion.html(items);
                dvRegion.show();
                hdHasRegion.val('true');
            }
            else {
                dvRegion.hide();
                ddlRegion.val("");
                ddlRegion.html("");
                hdHasRegion.val('false');
            }
        }).fail(function () {
            dvRegionLoader.hide();
        });
    },

    bindTooltipsHiding: function () {
        if (this.tooltipsAreUsed) {
            $(window).resize(function () {
                $(":input").tooltip("hide");
            });
        }
    },

    showValidationMessages: function (scrollToError) {
        var pageObj = this, isFirstElement = true;

        setTimeout(function () {

            $(':input[data-validation-error][data-validation-error!=""]:visible').each(function () {
                var inputObj = $(this);
                WCC.System.markControlAsInvalid(inputObj, inputObj.data("validation-error"));

                if (scrollToError == true) {

                    if (isFirstElement) { //scroll to only the first element in the erroneous list

                        if (inputObj.offset() != null) {
                            var scrollPos = inputObj.offset().top - 50;

                            $('html, body').animate({
                                scrollTop: scrollPos
                            }, 1000);
                        }

                        isFirstElement = false;
                    }
                }
            });
        }, 500);
    },

    showErrors: function (errorsList, generalObject, scrollToFirstError, context) {
        var errors = errorsList.errors || errorsList.Errors || {},
            generalError = errors.generalError || errors.Error;

        if (!generalError && errors.errors && errors.errors.generalError) {
            generalError = errors.errors.generalError;
        }
        if (generalError) {
            WCC.System.showErrorMessage(generalError);
        }

        if (errors) {
            var isFirstElement = true;
            $.each(errors, function (fieldName, message) {
                if (fieldName == "generalError") {
                    return true;
                }
                var inputObj = $(":input[name=\"" + fieldName.replace(/[[\].]/g, function (match) { return "\\" + match }) + "\"]", context),
                    offsetTop = 0;

                if (inputObj.length) {
                    if (inputObj.attr('data-validate-field')) { //for e.g., if it is a date field or html editor field, check validate-field to set the error on the display field or container div and not the actual field
                        inputObj = $(inputObj.attr('data-validate-field'));
                        offsetTop = inputObj.offset().top;
                        WCC.System.markControlAsInvalid(inputObj, message);
                    }
                    else if (inputObj.hasClass("select2")) { //if it's a select2 control (either binded on a hidden field or a select) then validation works differently
                        offsetTop = inputObj.select2("container").offset().top;
                        WCC.System.markControlAsInvalid(inputObj, message);
                    }
                    else { //if normal textbox
                        offsetTop = inputObj.offset().top;
                        WCC.System.markControlAsInvalid(inputObj, message);
                    }

                    if (scrollToFirstError == true) {
                        if (isFirstElement) { //scroll to only the first element in the erroneous list
                            if (inputObj.offset() != null) {
                                var scrollPos = offsetTop - 50;
                                $('html, body').animate({
                                    scrollTop: scrollPos
                                }, 1000);
                            }
                            isFirstElement = false;
                        }
                    }
                }
            });
        }
    },

    convertSelectToJson: function (selectId, context) {
        var arr = [];
        $(selectId + " > option", context).each(function () {
            if ($(this).val() != '') {
                arr.push({ id: $(this).val(), text: $(this).text() });
            }
        });
        return arr;
    },

    setCookie: WCC.System.setCookie,

    getCookie: WCC.System.getCookie,

    deleteCookie: WCC.System.deleteCookie,

    // prepend some leading zeros to a given number
    padNumber: function (number, pad) {

        var max = '1';

        for (var i = 0; i < (pad - 1) ; i++)
            max += '0';

        max = parseInt(max);

        if (number < max) {

            var padding = (max - number).toString().length;

            var no = '';

            for (var i = 0; i < padding; i++)
                no += '0';

            no += number;
            return no;
        }
        else
            return number;
    },

    //shows information/error messages at the top of the page
    showInformationMessage: function (control, msg, scrollToMsg) {

        control.text(msg);
        control.slideDown(500);

        if (scrollToMsg == true) {
            if (control.offset() != null) {
                var scrollPos = control.offset().top - 50;
                $('html, body').animate({ scrollTop: scrollPos }, 1000, 'swing', function () { setTimeout(function () { control.slideUp(500); }, 3000); });
            }
        }
        else {
            setTimeout(function () { control.slideUp(500); }, 3000);
        }
    },

    //Smart drowndowns - Dropdows used in bootstrap links
    initSmartDropdowns: function (mainForm, callout /*callout is a function pointer */, context) {
        var pageObj = this,
            dropDowns = context == null ? $(mainForm + " .dropdown-menu:not(.notSmart)") : $(".dropdown-menu:not(.notSmart)", context); //if context is defined, init dropdowns in that context else use selector

        dropDowns.each(function () {
            var dropdownObj = $(this);
            dropdownObj.closest('.dropdown').find('a.dropdown-toggle').addClass('jsTextLink');
            $('a:not(.no-click)', this).click(function () {
                if ($(this).hasClass("active")) {
                    return;
                }
                var clickedLink = $(this),
                    ulObj = clickedLink.closest("ul"),
                    targetLink = ulObj.prev();
                if (targetLink.hasClass('dropdown-backdrop')) //Bootstrap inserts an overlay on mobile devices sometimes therefore we need go up once more
                    targetLink = targetLink.prev();
                if (clickedLink.hasClass("callout")) {
                    if (callout != null) {
                        if (clickedLink.hasClass('block-it')) {
                            /*pass the control's id which should be used to trigger clean up operation (by calling it's click event manually) in case something goes wrong
                            e.g. if 'Show a Badge with image' option is selected, the id of 'Dont show a badge' option will be passed here so that if something goes wrong in the
                            callout function (like dismissal of popup without selecting a badge in this case), the click event of this cleanup control is called.*/
                            callout.call(pageObj, $($(this).data('revert')));
                        }
                    }
                }
                if (!clickedLink.hasClass('block-it')) {
                    $("a.active", ulObj).removeClass("active");
                    if (clickedLink.hasClass("select")) {
                        targetLink.html(clickedLink.data("html") || clickedLink.html());
                    }
                    if (clickedLink.hasClass("switch")) {
                        $(clickedLink.data("show")).each(function () {
                            var elementToShow = $(this);
                            if (elementToShow.hasClass("hiding")) {
                                elementToShow.show();
                            }
                            else {
                                elementToShow.css("visibility", "visible");
                            }
                            if (elementToShow.hasClass('init-select'))
                                $('li:first > a', elementToShow).click();


                            if (elementToShow.hasClass('init-select-by-data')) {
                                var valueToSet = $($('a.dropdown-toggle', elementToShow).attr('data-valuefield')).val();
                                $('ul li a[data-value="' + valueToSet + '"]', elementToShow).click().addClass('active');
                            }

                            //Sometimes we need to re-select the item for sub-actions to be performed
                            if (WCC.isNotNullOrEmpty(clickedLink.attr('data-reset-menu-container'))) {
                                var dataResetMenuCcontainer = $(clickedLink.attr('data-reset-menu-container')),
                                    currentVal = $(':input[type=hidden]:first', dataResetMenuCcontainer).val();

                                $('li a[data-value="' + currentVal + '"]', dataResetMenuCcontainer).removeClass('active').click().addClass('active');
                            }
                        });
                        $(clickedLink.data("hide")).each(function () {
                            var elementToHide = $(this);
                            if (elementToHide.hasClass("hiding")) {
                                elementToHide.hide();
                            }
                            else {
                                elementToHide.css("visibility", "hidden");
                            }
                            if (elementToHide.hasClass('html5editor'))
                                $('textarea', elementToHide).first().data("wysihtml5").editor.clear();
                        });
                        $(targetLink.data("valuefield")).val(clickedLink.data("value"));
                        if (clickedLink.data('other-values') != '') {
                            var jsonParsedData = clickedLink.data('other-values');
                            for (var key in jsonParsedData) {
                                $(key).val(jsonParsedData[key]);
                            }
                        }
                        if (!targetLink.hasClass('no-target-update')) {
                            targetLink.html(clickedLink.data("html") || clickedLink.html());
                        }
                    }
                    if (clickedLink.hasClass("clear")) {
                        var valueField = $(targetLink.data("valuefield")),
                            associatedField = valueField.data('associated-field');
                        valueField.val("");
                        if (clickedLink.data('other-values') != null) {
                            var jsonParsedData = clickedLink.data('other-values');
                            for (var key in jsonParsedData) {
                                $(key).val("");
                            }
                        }
                        if (associatedField != null) {
                            var assocField = $(associatedField);
                            assocField.each(function (index, element) {
                                if ($(this).is("a"))
                                    $(this).text("");
                                else
                                    $(this).val("");
                            });
                        }
                    }
                    if (clickedLink.hasClass("clearall")) { //clear all inputs in the controls which are to be hided 
                        var parent = $($(this).data('hide'));
                        parent.each(function () {
                            $(':input', $(this)).val('');
                            if (clickedLink.hasClass("setdefault")) { //select the first default option
                                $('.dropdown', $(this)).each(function () {
                                    $('li:first > a', $(this)).click();
                                });
                            }
                        });
                    }
                    if (targetLink.data("valuefield")) {
                        $(targetLink.data("valuefield")).val(clickedLink.data("value"));
                    }
                    if (clickedLink.data('other-values') != null) {
                        var jsonParsedData = clickedLink.data('other-values');
                        for (var key in jsonParsedData) {
                            $(key).val(jsonParsedData[key]);
                        }
                    }
                    if (!clickedLink.hasClass('set-no-active')) {
                        clickedLink.addClass("active");
                    }
                    if (clickedLink.hasClass("copydata")) { //exchange values based on data-exchange attribute
                        var dataValues = $(this).data('copy');
                        for (var key in dataValues) {
                            var sourceControl = $(key),
                                targetControl = $(dataValues[key]);
                            if (sourceControl.val() != '') {
                                if (targetControl.hasClass('html5editor'))
                                    $('textarea', targetControl).first().data("wysihtml5").editor.setValue(sourceControl.val());
                                else
                                    targetControl.val(sourceControl.val());
                            }
                        }
                    }
                    if (clickedLink.attr('data-callback')) {
                        var callBackParts = clickedLink.attr('data-callback').split(",");
                        if (callBackParts.length) {
                            var callBackName = callBackParts[0],
                                callBackParams = callBackParts.splice(1);

                            if (WCC.CurrentPage[callBackName]) {
                                WCC.CurrentPage[callBackName].call(pageObj, $(this), callBackParams);
                            }
                        }
                    }
                    if (clickedLink.hasClass('callout')) {
                        clickedLink.addClass('block-it');
                    }
                }
                clickedLink.closest(".dropdown").removeClass("open");
                return false;
            });

            if (dropdownObj.attr('data-set-default') == 'true') {
                var defaultVal = $(dropdownObj.prev().attr('data-valuefield')).val();
                if (defaultVal) {
                    dropdownObj.find('a[data-value="' + defaultVal + '"]:eq(0)').click().addClass('active');
                }
                else {
                    var defaultIndex = dropdownObj.attr('data-default-value-index');
                    if (defaultIndex == null) {
                        defaultIndex = 0;
                    }
                    setTimeout(function () {
                        dropdownObj.find('a:eq(' + defaultIndex + ')').click().addClass('active');
                    }, 500);
                }
            }
        });
    },

    //used in 'Create New' pages which appear when there are no records (applies to pages like members, other administrators, groups etc)
    initCreateNewLinks: function () {
        $('.createItemRow').each(function () {
            var groupRowDiv = $(this);
            groupRowDiv.click(function () {
                location.href = groupRowDiv.find("a.createItem.link").attr('href');
            });
        });
    },

    sortSelectBox: function (selector) {
        var select = $(selector),
            options = $('option', select),
            texts = new Array();

        $.each(options, function () {
            var option = $(this);
            texts.push({ id: option.val(), text: option.text() });
        })

        $('option', select).remove();
        texts.sort(function (a, b) { return a.text.localeCompare(b.text) >= 0; });

        for (var i in texts) {
            select.append('<option value="' + texts[i].id + '">' + texts[i].text + '</option>');
        }
    },

    invokeServerMethod: function () {
        if (this.isSignalRInitialized) {
            try {
                this.notificationHub.hub.invoke.apply(this.notificationHub.hub, arguments);
            } catch (ex) {
                if (console && console.log) {
                    console.log(ex);
                }
            }
        }
    },

    requestStarted: function (spinnerFieldset) {
        var spinner = null;
        $('#nonEditableCover').show();
        if (spinnerFieldset)
            spinner = WCC.System.initSpinner(spinnerFieldset[0]);
        return spinner;
    },

    requestStopped: function (spinner) {
        $('#nonEditableCover').hide();
        if (spinner) {
            spinner.stop();
        }
    }
});


///////////////////////////////////////
///                                 ///
///           Other stuff           ///
///                                 ///
///////////////////////////////////////


WCC.Reactor = (function () {
    function Event(name) {
        this.name = name;
        this.callbacks = [];
    }
    Event.prototype.registerCallback = function (callback) {
        this.callbacks.push(callback);
    }

    function Reactor() {
        this.events = {};
        this.groups = {};
    }

    Reactor.prototype.registerEvent = function (eventName, groupName) {
        if (groupName) {
            if (!this.groups[groupName].events[eventName]) {
                var event = new Event(eventName);
                this.groups[groupName].events[eventName] = event;
            }
        }
        else {
            if (!this.events[eventName]) {
                var event = new Event(eventName);
                this.events[eventName] = event;
            }
        }
    };

    Reactor.prototype.dispatchEvent = function (eventName, eventArgs) {
        if (this.events[eventName] && this.events[eventName].callbacks) {
            this.events[eventName].callbacks.forEach(function (callback) {
                callback(eventArgs);
            });
        }
        $.each(this.groups, function (i, group) {
            if (group.events[eventName] && group.events[eventName].callbacks) {
                group.events[eventName].callbacks.forEach(function (callback) {
                    callback(eventArgs);
                });
            }
        });
    };

    Reactor.prototype.on = function (_eventName, callback, unbindPrevious, groupName) {
        const self = this,
            eventsNames = Array.isArray(_eventName) ? _eventName : [_eventName];
        if (unbindPrevious) {
            self.unbindEvent(_eventName, groupName);
        }
        $.each(eventsNames, function (i, eventName) {
            if (groupName) {
                if (!self.groups[groupName]) {
                    self.groups[groupName] = { events: {} };
                }
                self.registerEvent(eventName, groupName);
                self.groups[groupName].events[eventName].registerCallback(callback);
            }
            else {
                self.registerEvent(eventName);
                self.events[eventName].registerCallback(callback);
            }
        });
    };

    Reactor.prototype.off = function (eventName, callback) {
        const self = this,
            eventsNames = _(eventName).isArray() ? eventName : [eventName];

        _(eventsNames).each((eventName) => {
            if (self.events[eventName]) {
                if(callback) {
                    // we have a callback to remove. remove that callback only
                    const idx = self.events[eventName].callbacks.indexOf(callback);

                    if (idx !== -1) {
                        self.events[eventName].callbacks.splice(idx, 1);

                        if (self.events[eventName].callbacks.length === 0) {
                            self.events[eventName] = undefined;
                        }
                    }
                }
                else {
                    // no callback provided. remove all callbacks
                    self.events[eventName].callbacks = [];
                    self.events[eventName] = undefined;
                }
            }
        });
    };

    Reactor.prototype.unbindEvent = function (_eventName, groupName) {
        const self = this,
            eventsNames = Array.isArray(_eventName) ? _eventName : [_eventName];
        $.each(eventsNames, function (i, eventName) {
            if (groupName) {
                if (self.groups[groupName] && self.groups[groupName].events[eventName]) {
                    delete self.groups[groupName].events[eventName];
                }
            }
            else {
                if (self.events[eventName]) {
                    delete self.events[eventName];
                }
            }
        });
    };

    return new Reactor();
})();

// Namespace for all functions that can be added at run-time by any scripts or hooks
WCC.TempFuncions = {};

// jQuery shim for placeholder support for non compliant browsers
// https://github.com/parndt/jquery-html5-placeholder-shim
(function ($) {
    $.extend($, {
        placeholder: {
            browser_supported: function () {
                return this._supported !== undefined ?
                  this._supported :
                  (this._supported = !!('placeholder' in $('<input type="text">')[0]));
            },
            shim: function (opts) {
                var config = {
                    color: '#888',
                    cls: 'placeholder',
                    selector: 'input[placeholder], textarea[placeholder]'
                };
                $.extend(config, opts);
                return !this.browser_supported() && $(config.selector)._placeholder_shim(config);
            }
        }
    });

    $.extend($.fn, {
        _placeholder_shim: function (config) {
            function calcPositionCss(target) {
                var op = $(target).offsetParent().offset();
                var ot = $(target).offset();

                return {
                    top: ot.top - op.top,
                    left: ot.left - op.left,
                    width: $(target).width()
                };
            }
            function adjustToResizing(label) {
                var $target = label.data('target');
                if (typeof $target !== "undefined") {
                    label.css(calcPositionCss($target));
                    $(window).one("resize", function () { adjustToResizing(label); });
                }
            }
            return this.each(function () {
                var $this = $(this);

                if ($this.is(':visible')) {

                    if ($this.data('placeholder')) {
                        var $ol = $this.data('placeholder');
                        $ol.css(calcPositionCss($this));
                        return true;
                    }

                    var possible_line_height = {};
                    if (!$this.is('textarea') && $this.css('height') != 'auto') {
                        possible_line_height = { lineHeight: $this.css('height'), whiteSpace: 'nowrap' };
                    }

                    var ol = $('<label />')
                      .text($this.attr('placeholder'))
                      .addClass(config.cls)
                      .css($.extend({
                          position: 'absolute',
                          display: 'inline',
                          float: 'none',
                          overflow: 'hidden',
                          textAlign: 'left',
                          color: config.color,
                          cursor: 'text',
                          paddingTop: $this.css('padding-top'),
                          paddingRight: $this.css('padding-right'),
                          paddingBottom: $this.css('padding-bottom'),
                          paddingLeft: $this.css('padding-left'),
                          fontSize: $this.css('font-size'),
                          fontFamily: $this.css('font-family'),
                          fontStyle: $this.css('font-style'),
                          fontWeight: $this.css('font-weight'),
                          textTransform: $this.css('text-transform'),
                          backgroundColor: 'transparent',
                          zIndex: 99
                      }, possible_line_height))
                      .css(calcPositionCss(this))
                      .attr('for', this.id)
                      .data('target', $this)
                      .click(function () {
                          $(this).data('target').focus();
                      })
                      .insertBefore(this);
                    $this
                      .data('placeholder', ol)
                      .focus(function () {
                          ol.hide();
                      }).blur(function () {
                          ol[$this.val().length ? 'hide' : 'show']();
                      }).triggerHandler('blur');
                    $(window).one("resize", function () { adjustToResizing(ol); });
                }
            });
        }
    });
})(jQuery);

//jquery extensions
(function ($, undefined) {
    //extension to get cursor position for textfield
    $.fn.getCursorPosition = function () {
        var el = $(this).get(0);
        var pos = 0;
        if ('selectionStart' in el) {
            pos = el.selectionStart;
        } else if ('selection' in document) {
            el.focus();
            var Sel = document.selection.createRange();
            var SelLength = document.selection.createRange().text.length;
            Sel.moveStart('character', -el.value.length);
            pos = Sel.text.length - SelLength;
        }
        return pos;
    }
    //extension to insert text at the current cursor positionhttp://127.0.0.1/../ContentBuilder
    $.fn.insertTextAtCurrentPosition = function (text) {
        var ctrl = $(this),
            currPos = ctrl.getCursorPosition(),
            len = ctrl.val().length;

        if (currPos == len)
            ctrl.val(ctrl.val() + text);
        else {
            if (currPos >= 0 && currPos < len) {
                var left = ctrl.val().substr(0, currPos),
                    right = ctrl.val().substr(currPos, len - currPos);

                ctrl.val(left + text + right);
            }
        }
    }
})(jQuery);

jQuery(document).add(window).bind('ready load', function () {
    if (jQuery.placeholder) {
        jQuery.placeholder.shim();
    }
});

/* override bootstrap popover to include callback */
var showPopover = $.fn.popover.Constructor.prototype.show;
$.fn.popover.Constructor.prototype.show = function () {
    showPopover.call(this);
    if (this.options.showCallback) {
        this.options.showCallback.call(this);
    }
}

export { WCC }